import React from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import {replace} from "react-router-redux";
import { NotificationManager } from 'react-notifications';

import UserRoles from "../../../../../common/src/enums/UserRoles";
import {getRegi, isDefined} from "../../../../../common/src/util/lib";
import { ROUTE_RACE, ROUTE_RACES } from '../../../constants/routeconstants';
import * as AdminActions from "../../../actions/admin";
import * as RaceActions from "../../../actions/race";

import RaceGeneral from "./subPages/RaceGeneral";
import RaceSignup from "./subPages/RaceSignup";
import RaceArrival from "./subPages/RaceArrival";
import RaceWatch from "./subPages/RaceWatch";
import RaceMemberComp from "./subPages/RaceMemberComp";
import RacePrices from "./subPages/RacePrices";
import RaceDecay from "./subPages/RaceDecay";

import { CompressList } from '../../../../../common/src/util/lib';

class RacePage extends React.Component {

    static getId() {
        return ROUTE_RACE;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN, UserRoles.SECTION_ADMIN, UserRoles.CLUB_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            allowNew: false,
        }
    }

    componentDidMount() {
        this.loadRace(this.props);
        if (this.props.admin.stations.size === 0) this.props.dispatch(AdminActions.getListItems('station'));
        if (this.props.admin.sections.size === 0) this.props.dispatch(AdminActions.getSections());
        if (!this.props.admin.isClubsRead) this.props.dispatch(AdminActions.getClubs());
        if (this.props.race.deposits.size === 0 || this.props.race.markings.size === 0) this.props.dispatch(RaceActions.getBasics());
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params.raceNo !== this.props.params.raceNo) this.loadRace(nextProps);
    }

    loadRace = newestProps => {
        if (newestProps.params.raceNo.toLowerCase() !== 'new') newestProps.dispatch(RaceActions.getRace(newestProps.params.raceNo, () => {this.forceUpdate();}));
    };

    subForm = null;
    render() {
        // Get race from Redux state.
        const raceNo = this.props.params.raceNo;
        const race = raceNo.toLowerCase() === 'new' || !this.props.race.races ? null : this.props.race.races.get(Number(raceNo)) || null;
        if (raceNo.toLowerCase() !== 'new' && (race === null || typeof(race.isFullLoaded) === 'undefined')) return null;

        const groups = CompressList(race === null ? null : race.Sektionsgrupper);
        const sections = CompressList(race === null ? null : race.Sektioner);

        let subPage = null;
        switch (this.props.params.subpage) {
            case 'general':
                if (this.props.admin.sections.size > 0) subPage = <RaceGeneral race={race} editMode={this.props.params.mode === 'edit' || this.props.params.mode === 'create'} ref={instance => {this.subForm = instance;}}/>
                break;
            case 'signup':
                subPage = <RaceSignup race={race} setEditMode={this.setEditMode} setAllowNew={this.setAllowNew} ref={instance => {this.subForm = instance;}}/>;
                break;
            case 'watch':
                subPage = <RaceWatch race={race} setEditMode={this.setEditMode} setAllowNew={this.setAllowNew} ref={instance => {this.subForm = instance;}}/>;
                break;
            case 'arrival':
                subPage = <RaceArrival race={race} setEditMode={this.setEditMode} ref={instance => {this.subForm = instance;}}/>;
                break;
            case 'member-comp':
                subPage = <RaceMemberComp race={race} ref={instance => {this.subForm = instance;}}/>;
                break;
            case 'prices':
                subPage = <RacePrices race={race} setEditMode={this.setEditMode} setAllowNew={this.setAllowNew} ref={instance => {this.subForm = instance;}}/>;
                break;
            case 'decay':
                subPage = <RaceDecay race={race} ref={instance => {this.subForm = instance;}}/>;
                break;
        }

        return (<div>
            <div className="sub-page-title">
                <h2>{raceNo.toLowerCase() === 'new' ? 'Ny kapflyvning' : 'Kapflyvning ' + race.Farvekode + ' i uge ' + String(race.Uge) + (race.Sektion === null ? '' : ', Sektion ' + race.Sektion) + (groups.items.length === 0 ? '' : ', Gruppe ' + groups.items.join(',')) + (sections.items.length === 0 ? '' : ', Sektion ' + sections.items.join(','))}</h2>
            </div>
            <div className="sub-page-content">
                <div className="tab-list">
                    <Link className={(this.props.params.subpage === 'general' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'))} to={this.props.params.mode === 'view' && !this.state.editMode ? ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "general").replace(":mode", "view") : ''}>
                        <span className="tab-text">Generelt</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'signup' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'))} to={this.props.params.mode === 'view' && !this.state.editMode ? ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "signup").replace(":mode", "view") : ''}>
                        <span className="tab-text">Anmeld</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'watch' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'))} to={this.props.params.mode === 'view' && !this.state.editMode ? ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "watch").replace(":mode", "view") : ''}>
                        <span className="tab-text">Ure</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'arrival' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'))} to={this.props.params.mode === 'view' && !this.state.editMode ? ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "arrival").replace(":mode", "view") : ''}>
                        <span className="tab-text">Hjemkomst</span>
                    </Link>
                    {this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && race !== null && getRegi(race.Farvekode) !== 'Sektion' ? null : <Link className={(this.props.params.subpage === 'member-comp' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'))} to={this.props.params.mode === 'view' && !this.state.editMode ? ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "member-comp").replace(":mode", "view") : ''}>
                        <span className="tab-text">Slagspil</span>
                    </Link>}
                    {this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && race !== null && getRegi(race.Farvekode) !== 'Sektion' ? null : <Link className={(this.props.params.subpage === 'prices' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'))} to={this.props.params.mode === 'view' && !this.state.editMode ? ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "prices").replace(":mode", "view") : ''}>
                        <span className="tab-text">Præmier</span>
                    </Link>}
                    {this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && race !== null ? null : <Link className={(this.props.params.subpage === 'decay' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' && !this.state.editMode ? '' : ' disabled'))} to={this.props.params.mode === 'view' && !this.state.editMode ? ROUTE_RACE.replace(":raceNo", raceNo).replace(":subpage", "decay").replace(":mode", "view") : ''}>
                        <span className="tab-text">Forfald</span>
                    </Link>}
                </div>
                <div className="tab-page">
                    {subPage}
                </div>
            </div>
            <div className="sub-page-actions">
                {this.props.params.mode === 'view' && !this.state.editMode ? [
                    <span className="left-buttons" key="left">
                        {this.props.params.subpage === 'general' ? <button className="btn-primary" title="Rediger kapflyvning" onClick = {() => {
                            this.props.dispatch(replace(ROUTE_RACE.replace(':raceNo', raceNo).replace(':subpage', this.props.params.subpage).replace(':mode', 'edit')));
                        }}>Rediger</button> : null}
                        {this.props.params.subpage === 'signup' || this.props.params.subpage === 'watch' || this.props.params.subpage === 'prices' ? <button className="btn-primary" title={this.props.params.subpage === 'watch' ? 'Opret ur' : 'Opret deltager'} disabled={!this.state.allowNew} onClick = {() => {
                            this.subForm.getWrappedInstance().createNew();
                        }}>Ny</button> : null}
                    </span>,
                    <span className="right-buttons" key="right">
                        <Link className="btn-primary" to={ROUTE_RACES + '?week=' + race.Uge} title="Vis alle kapflyvninger">
                            Kapflyvninger
                        </Link>
                    </span>
                ] : [
                    <span className="left-buttons" key="left">
                        <button className="btn-primary" title="Gem ændringer" onClick = {() => {
                            if (this.props.params.subpage === 'general')
                                this.subForm.getWrappedInstance().save(raceNo => {
                                    NotificationManager.success(this.props.params.raceNo.toLowerCase() === 'new' ? "Kapflyvningen er oprettet" : "Kapflyvningen er opdateret.", this.props.params.raceNo.toLowerCase() === 'new' ? "Oprettelse" : "Opdatering", 4000);
                                    this.props.dispatch(replace(ROUTE_RACE.replace(':raceNo', raceNo).replace(':subpage', this.props.params.subpage).replace(':mode', 'view')));
                                });
                            else if (this.props.params.subpage === 'signup' || this.props.params.subpage === 'watch' || this.props.params.subpage === 'arrival' || this.props.params.subpage === 'prices')
                                this.subForm.getWrappedInstance().save();
                        }}>Gem</button>
                    </span>,
                    <span className="right-buttons" key="right">
                        <button className="btn-secondary" title="Annuller ændringer" onClick = {() => {
                            if (this.props.params.subpage === 'general') {
                                if (raceNo.toLowerCase() === 'new') this.props.dispatch(replace(ROUTE_RACES));
                                else this.props.dispatch(replace(ROUTE_RACE.replace(':raceNo', raceNo).replace(':subpage', this.props.params.subpage).replace(':mode', 'view')));
                            } else if (this.props.params.subpage === 'signup' || this.props.params.subpage === 'watch' || this.props.params.subpage === 'arrival' || this.props.params.subpage === 'prices')
                                this.subForm.getWrappedInstance().cancelEdit();
                        }}>Annuller</button>
                    </span>,
                ]}
            </div>
        </div>);
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    setEditMode = mode => this.setState({editMode: mode});

    setAllowNew = mode => this.setState({allowNew: mode});
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        stations: state.admin.stations,
        sections: state.admin.sections,
        isClubsRead: state.admin.isClubsRead,
        clubs: state.admin.clubs
    },
    race: {
        races: state.race.races,
        deposits: state.race.deposits,
        markings: state.race.markings,
    }
});

export default connect(mapStateToProps)(RacePage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/race/RacePage.js